export const environment = {
  production: false,
  hmr: true,
  version: '1.0.0',
  serverUrl: "https://dev.locaviaweb.com.br/portaldocliente/v1",
  serverAuthUrl: "https://dev.locaviaweb.com.br/portaldocliente/v1",
  serverLwUrl: "https://dev.locaviaweb.com.br/api-locaviaweb/v1",
  defaultLanguage: 'pt-BR',
  supportedLanguages: ['pt-BR', 'en-US'],
};